function cov_17eh3iux71() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/i18n/translationHelper.ts";
  var hash = "1971d609977dde7078e14d4e352a1fbc77d8a9b1";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/i18n/translationHelper.ts",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 17
        },
        end: {
          line: 6,
          column: 1
        }
      },
      "1": {
        start: {
          line: 5,
          column: 2
        },
        end: {
          line: 5,
          column: 30
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 4,
            column: 17
          },
          end: {
            line: 4,
            column: 18
          }
        },
        loc: {
          start: {
            line: 4,
            column: 91
          },
          end: {
            line: 6,
            column: 1
          }
        },
        line: 4
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "1971d609977dde7078e14d4e352a1fbc77d8a9b1"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_17eh3iux71 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_17eh3iux71();
import i18n from "./index.mjs";
cov_17eh3iux71().s[0]++;
export var t = function t(key, options) {
  cov_17eh3iux71().f[0]++;
  cov_17eh3iux71().s[1]++;
  return i18n.t(key, options);
};
//# sourceMappingURL=translationHelper.mjs.map